import {instance} from "./";

export const getProgramsList = () => {
  return instance({
    method: "get",
    url: "/work/api/program"
  });
};

export const getActualProgramsList = () => {
  return instance({
    method: "get",
    url: "/work/api/actual-programs"
  });
};

export const getActualProgramsListByTargetGroupAndMunicipal = (targetGroup, municipal) => {
  return instance({
    method: "get",
    url: `/work/api/actual-programs/targetGroup/${targetGroup}/municipal/${municipal}`
  });
};

export const getActualProgramGroups = (id) => {
  const response = instance({
    method: "get",
    url: `/work/api/program/${id}/groups`
  });
  return response;
};

export const getProgramCard = id => {
  return instance({
    method: "get",
    url: `/work/api/program/${id}/card`
  });
};

export const getModuleCard = id => {
  return instance({
    method: "get",
    url: `/work/api/module/${id}/card`
  });
};

export const getProgramFullInfo = id => {
  return instance({
    method: "get",
    url: `/work/api/program/${id}`
  });
};

export const getModuleFullInfo = id => {
  return instance({
    method: "get",
    url: `/work/api/module/${id}`
  });
};

export const getModulePurpose = id => {
  return instance({
    method: "get",
    url: `/work/api/module/${id}/purpose`
  });
};

export const getProgramPhotos = (id) => {
  return instance({
    method: "get",
    url: `/work/api/program/${id}/main/photo`
  });
};

export const getProgramAuthorList = (id) => {
  return instance({
    method: "get",
    url: `/work/api/program/${id}/main/authors`
  });
};

export const getProgramHtmlAnounce = (id) => {
  return instance({
    method: "get",
    url: `/work/api/program/${id}/anounce`
  });
};

export const getProgramHtmlDescription = (id) => {
  return instance({
    method: "get",
    url: `/work/api/program/${id}/description`
  });
};

export const deleteLogo = (id) => {
  return instance({
    method: "delete",
    url: `/work/api/program/${id}/logo`,
  });
};

export const updateLogo = (id, file) => {
  const data = new FormData();
  data.set('file', file);

  return instance({
    method: "post",
    url: `/work/api/program/${id}/logo`,
    headers: {
      "Content-Type": "multipart/form-data",
    },
    data
  });
};

export const updateDocument = (id, file) => {
  const data = new FormData();
  data.set('file', file);

  return instance({
    method: "post",
    url: `/work/api/program/${id}/program`,
    headers: {
      "Content-Type": "multipart/form-data",
    },
    data
  });
};

export const deleteDocument = (id) => {
  return instance({
    method: "delete",
    url: `/work/api/program/${id}/program`,
  });
};

export const updateCertificate = (id, file) => {
  const data = new FormData();
  data.set('file', file);

  return instance({
    method: "post",
    url: `/work/api/program/${id}/certificate`,
    headers: {
      "Content-Type": "multipart/form-data",
    },
    data
  });
};

export const deleteCertificate = (id) => {
  return instance({
    method: "delete",
    url: `/work/api/program/${id}/certificate`,
  });
};

export const getEducationOrgList = () => {
  return instance({
    method: "get",
    url: "/work/api/organization?mode=select&offerEducation=true"
  });
};

export const getEducationFormList = () => {
  return instance({
    method: "get",
    url: "/work/api/dict/education-form"
  });
};

export const getTargetGroupList = () => {
  return instance({
    method: "get",
    url: "/work/api/dict/target-group"
  });
};

export const addNewProgramInformation = (data) => {
  return instance({
    method: "post",
    url: `/work/api/program/`,
    data
  });
};

export const updateProgramInformation = (id, data) => {
  return instance({
    method: "put",
    url: `/work/api/program/${id}`,
    data
  });
};

export const deleteProgram = (id) => {
  return instance({
    method: "delete",
    url: `/work/api/program/${id}`,
  });
};

export const sendProgramToCatalog = (id) => {
  return instance({
    method: "post",
    url: `/work/api/program/${id}/send`
  });
}

export default {
  getEducationOrgList,
  getEducationFormList,
  getTargetGroupList,
  getProgramsList,
  getActualProgramsList,
  getActualProgramGroups,
  getActualProgramsListByTargetGroupAndMunicipal,
  getProgramCard,
  getProgramFullInfo,
  getProgramPhotos,
  getProgramHtmlAnounce,
  getProgramHtmlDescription,
  getModuleCard,
  getModuleFullInfo,
  getModulePurpose,
  updateLogo,
  updateDocument,
  updateCertificate,
  deleteProgram,
  deleteLogo,
  deleteDocument,
  deleteCertificate,
  addNewProgramInformation,
  updateProgramInformation,
  sendProgramToCatalog
};
